<template>
    <main class="main-content" id="main-content">
        <div class="container">
          <section class="section">
            <page-header>
                <template v-slot:pageTitle>
                  {{$t("details")}}
                </template>
            </page-header>
            <div class="section__body">
              <div class="detailing">
                <!-- <div class="detailing__header">
                  <div class="btn-group nav nav-tabs" role="tablist">
                    <a class="btn btn_default btn_white nav-link active" id="telephony-tab" data-toggle="tab" href="#telephony" role="tab" aria-controls="telephony" aria-selected="false">{{$t("telephony")}}</a>
                    <a class="btn btn_default btn_white nav-link" id="internet-tab" data-toggle="tab" href="#internet" role="tab" aria-controls="internet" aria-selected="true">{{$t("internet")}}</a>
                  </div>
                </div> -->
                <div class="tab-content">
                  <div class="tab-pane fade" id="internet" role="tabpanel" aria-labelledby="internet-tab">
                    <div class="row detailing__header align-items-center">
                      <div class="col-12 col-md-auto">
                        <div class="section__title section__title_style3">{{$t("detailInternetTraffic")}}</div>
                      </div>
                    </div>
                    <div class="detailing__body">
                      <!-- <div class="warning__block">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            width="20" height="20" viewBox="0 0 128 128" enable-background="new 0 0 128 128" xml:space="preserve">
                          <g>
                            <g>
                              <path d="M126.314,104.844l-48.001-96C75.603,3.422,70.063,0,64,0c-6.063,0-11.602,3.422-14.313,8.844l-48.001,96
                                c-2.477,4.961-2.211,10.852,0.703,15.57c2.914,4.711,8.063,7.586,13.61,7.586h96.002c5.547,0,10.695-2.875,13.61-7.586
                                C128.525,115.695,128.791,109.805,126.314,104.844z M118.806,116.203c-1.445,2.344-4.055,3.797-6.805,3.797H15.999
                                c-2.75,0-5.36-1.453-6.805-3.789c-1.469-2.383-1.602-5.289-0.352-7.789l48.001-96C58.203,9.695,60.945,8,64,8
                                c3.055,0,5.797,1.695,7.156,4.422l48.001,95.992C120.407,110.922,120.274,113.828,118.806,116.203z M64,32c-4.415,0-8,3.586-8,8
                                v40c0,4.414,3.586,8,8,8c4.414,0,8-3.586,8-8V40C72,35.586,68.414,32,64,32z M64,96c-4.415,0-8,3.586-8,8s3.586,8,8,8
                                c4.414,0,8-3.586,8-8S68.414,96,64,96z"/>
                            </g>
                          </g>
                        </svg>
                        {{$t("detalisiationInfo")}}
                      </div> -->
                      <div class="input__block">
                        <month-picker-input :default-month="currentMonth" :lang="currentLang" :no-default="true"></month-picker-input>
                        <select class="contractList" v-model="idContract">
                          <option value="" disabled selected>{{$t("chooseContract")}}</option>
                          <option v-for="contract in contractObj" :key="contract.idContract" :value="contract.idContract">{{contract.numberContract}}</option>
                        </select>
                        <button class="send__btn" @click.prevent="sendRequest('internet')">{{$t("download")}}</button>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade show active" id="telephony" role="tabpanel" aria-labelledby="telephony-tab">
                    <div class="row detailing__header align-items-center">
                      <div class="col-12 col-md-auto">
                        <div class="section__title section__title_style3">{{$t("detailTelephony")}}</div>
                      </div>
                    </div>
                    <div class="detailing__body">
                      <div class="warning__block">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            width="20" height="20" viewBox="0 0 128 128" enable-background="new 0 0 128 128" xml:space="preserve">
                          <g>
                            <g>
                              <path d="M126.314,104.844l-48.001-96C75.603,3.422,70.063,0,64,0c-6.063,0-11.602,3.422-14.313,8.844l-48.001,96
                                c-2.477,4.961-2.211,10.852,0.703,15.57c2.914,4.711,8.063,7.586,13.61,7.586h96.002c5.547,0,10.695-2.875,13.61-7.586
                                C128.525,115.695,128.791,109.805,126.314,104.844z M118.806,116.203c-1.445,2.344-4.055,3.797-6.805,3.797H15.999
                                c-2.75,0-5.36-1.453-6.805-3.789c-1.469-2.383-1.602-5.289-0.352-7.789l48.001-96C58.203,9.695,60.945,8,64,8
                                c3.055,0,5.797,1.695,7.156,4.422l48.001,95.992C120.407,110.922,120.274,113.828,118.806,116.203z M64,32c-4.415,0-8,3.586-8,8
                                v40c0,4.414,3.586,8,8,8c4.414,0,8-3.586,8-8V40C72,35.586,68.414,32,64,32z M64,96c-4.415,0-8,3.586-8,8s3.586,8,8,8
                                c4.414,0,8-3.586,8-8S68.414,96,64,96z"/>
                            </g>
                          </g>
                        </svg>
                        {{$t("detalisiationInfo")}}
                      </div>
                      <div class="input__block">
                        <month-picker-input @change="showDate" :default-month="currentMonth" :lang="currentLang" :no-default="true"></month-picker-input>
                        <select class="contractList" v-model="idContract">
                          <option value="" disabled selected>{{$t("chooseContract")}}</option>
                          <option v-for="contract in contractObj" :key="contract.idContract" :value="contract.idContract">{{contract.numberContract}}</option>
                        </select>
                        <button class="send__btn" @click.prevent="sendRequest('tel')">{{$t("send")}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
    </main>
</template>
<script>
import PageHeader from "@/components/PageHeader";
import { MonthPickerInput } from 'vue-month-picker';
import {mapGetters, mapActions} from 'vuex'
export default {
  components: {
    PageHeader,
    MonthPickerInput
  },
  data() {
    return{
      date: {},
      idContract: '',
      currentDay: new Date().getDate(),
      currentMonth: new Date().getMonth()+1,
      currentYear: new Date().getFullYear(),
      currentLang: localStorage.getItem('locale') === 'en' ? 'en' : 'ru'
    }
  },
  computed: {
    ...mapGetters({
      contractObj: 'personaldata/contractObject',
    }),
  },
  methods: {
    ...mapActions({
      sendTelRequest: 'detailing/sendRequest',
      sendInternetRequest: 'detailing/sendInternetRequest'
    }),
    showDate (date) {
      this.date = date;
    },
    sendRequest(type) {    
      if(type === 'tel'){ 
        if((this.currentYear < this.date.year)  || ((this.currentYear === this.date.year) && (this.currentDay <= 10) && (this.currentMonth-1 <= this.date.monthIndex))){
          toastr.warning(this.$t("chooseCorrectDate"));
          return;
        }
        if(!this.idContract){
          toastr.warning(this.$t("chooseContract"));
          return;
        }
        let period = String(this.date.year).concat(this.date.monthIndex < 10 ? `0${this.date.monthIndex}` : this.date.monthIndex);
        let idContract = this.idContract
      
        this.sendTelRequest({period, idContract}).then((resp) => {
          if(resp === 'OK'){
            toastr.success(this.$t("requestSended"));
          }else if(resp === 'Email not found'){
            toastr.error(this.$t("incorrectEmail"));
          }else{
            toastr.error(this.$t("recoveryError"));
          }
        })
      }else{
        if(!this.date.year || (this.currentMonth < this.date.monthIndex)){
          toastr.warning(this.$t("chooseCorrectDate"));
          return;
        }
        if(!this.idContract){
          toastr.warning(this.$t("chooseContract"));
          return;
        }
        let period = String(this.date.year).concat(this.date.monthIndex < 10 ? `0${this.date.monthIndex}` : this.date.monthIndex);
        let idContract = this.idContract
        let language = localStorage.getItem('locale') || 'kz';
        this.sendInternetRequest({period, idContract, language}).then((res) => {
          this.convertToPdf(res.data.internet_detail_encoded_file)
        })
      }
    },
    convertToPdf(b64){
      let bin = atob(b64);

      // открыть файл в окне
      // let obj = document.createElement('object');
      // obj.style.width = '100%';
      // obj.style.height = '842pt';
      // obj.type = 'application/pdf';
      // obj.data = 'data:application/pdf;base64,' + b64;
      // document.body.appendChild(obj);

      // создание ссылки
      let link = document.createElement('a');
      link.innerHTML = 'Download PDF file';
      link.download = 'file.pdf';
      link.href = 'data:application/octet-stream;base64,' + b64;
      link.click();
      // document.body.appendChild(link);
    },
  }
}
</script>
<style scoped>
.input__date{
  border: none;
  flex-shrink: 0;
  width: 220px;
  flex-grow: 0;
  border: 1px solid #289853;
  border-radius: 8px;
}
.detailing__body{
  background-color: #fff;
  border-radius: 10px;
  width: 100%;
  padding: 10px 30px;
}
.input__block{
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 10px;
}
.send__btn{
  background-color: #268e54;
  padding: 10px 25px;
  color: #fff;
  border-radius: 10px;
  transition: all .2s ease-in;
}
.send__btn:hover{
  background-color: #196d3f;
}
.contractList{
  margin-left: 40px;
  background-color: #fff;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  padding: 10px 20px;
}
.warning__block{
  background-color: #eeab2e;
  padding: 10px 20px;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  column-gap: 10px;
}
.warning__block svg{
  fill: #fff;
}
@media (max-width: 768px) {
  .input__date{
    width: 50%;
  }
}
@media (max-width: 530px) {
  .contractList{
    margin-left: 0;
  }
}
@media (max-width: 488px) {
  .input__block{
    flex-direction: column;
  }
  .warning__block>svg{
    width: 45px;
    height: 45px;
  }
}
</style>